module.exports = __webpack_public_path__ + "media/72.896de7d6.mp3";